import styled from "styled-components";
import { colors } from "../../../styles/colors";

export const StyledLinksSettings = styled.div`
  margin-bottom: 40px;
  padding: 0 5px;

  .links-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 19px;
  }

  .add-link-icon {
    width: 40px;
    height: 40px;
    cursor: pointer;
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.1);
    }
  }

  .links-settings-subtitle {
    font-size: 12px;
    color: ${colors.blueGray};
    margin-bottom: 19px;
    border: 1px solid #ffcc00;
    width: fit-content;
    margin: 0 auto;
    border-radius: 100px;
    padding: 0 4px 0 9px;
    display: flex;
    align-items: center;
    height: 22px;
    gap: 8px;
    margin-top: 19px;
    margin-bottom: 19px;

    img {
      width: 12px;
      height: 12px;
    }
  }
`;
